import * as Yup from 'yup';

export const GetTokenSchema = (t: any) => Yup.object().shape({
  email: Yup.string()
      .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, t('noCorrectEmail'))
      .required(t('emailRequired'))
});
